import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class WooCommerceSizeMapApiClient extends AdvancedApiClient {

    static entityType = "WooCommerceSizeMap"

    constructor(token, sizeId, id) {
        super();

        this.setEntityType(WooCommerceSizeMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/size/{sid}/woocommerce-map/{id}")
                .setRouteParam("sid", sizeId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/size/{sid}/woocommerce-map")
                .setRouteParam("sid", sizeId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}